<template>
  <div>
    <h2>End Trial for {{siteName}}</h2>

    <div class="card">
      <div v-if="isTrialling">
        <div v-if="hasDefaultPaymentMethod">
          <p><strong>{{siteName}}</strong> is looking great.</p>

          <p>Because you've now got a default payment method associated with your account, you can proceed to end your trial early and benefit from PageMakerPro's paid plan.</p>

          <button @click="endSubscriptionTrial" class="btn is-primary">End trial now</button>
        </div>

        <div v-else>
          <p><strong>{{siteName}}</strong> is looking great.</p>

          <p>
            It doesn't look like you've added a payment method yet.
            Thankfully, it'll only take a second.
          </p>
          <p>
            Once you've added a default payment method, we'll take the first payment
            and activate your subscription!
          </p>
          <button @click="createPortalSession" class="btn is-primary">Add payment method</button>
        </div>
      </div>

      <div v-else>
        <p><strong>{{siteName}}</strong> isn't currently on any trials.</p>
      </div>
    </div>

    <hr>
  </div>
</template>

<script>
import {readCompanySiteData} from '@/lib/sites'

export default {
  name: 'end-subscription-trial',

  data() {
    return {
      site: {}
    }
  },

  props: {
    companyId: String,
    subscription: Object,
    siteId: String,
    hasDefaultPaymentMethod: Boolean
  },

  computed: {
    siteName() {
      return this.site.name
    },

    isTrialling() {
      return this.subscription ? this.subscription.status === 'trialing' : false
    }
  },

  methods: {
    getData() {
      // get site
      readCompanySiteData(this.companyId, this.siteId)
        .then(({data}) => {
          this.site = data
        })
        .catch(() => {
          alert('couldnt find site')
        })
    },

    getSubscription() {
      this.$emit('getSiteSubscription', this.siteId)
    },

    createPortalSession() {
      this.$emit('createPortalSession', '/payment-methods')
    },

    endSubscriptionTrial() {
      this.$emit('endSubscriptionTrial', this.siteId)
    }
  },

  mounted() {
    this.getData()
    this.getSubscription()
  }
}
</script>
